export const DASHBOARD = 'Dashboard';
export const PATH_TO_ADMIN = '/admin';
export const PATH_TO_DASHBOARD = '/dashboard';
export const CURRENT_PATH = 'currentPath';
export const BACK_TO_SEARCH_RESULT = 'Go back to Search Results';